import { PaletteColor, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    height: '100%',
    maxHeight: 632,
    overflowY: 'auto',
    padding: '1.5rem',
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '0.25rem',

    '& h6': {
      margin: 0,
      padding: 0,
      font: 'Sora',
      fontSize: '1.25rem',
      lineHeigth: '2rem',
      fontWeight: '600',
    },
  },

  closeBtn: {
    cursor: 'pointer',
    transition: 'all 300ms ease-in-out',

    '&:hover': {
      color: (theme.palette.anger as PaletteColor).main,
    },
  },

  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '1rem',
  },

  item: {
    padding: '0.5rem',
    borderRadius: '0.25rem',
    transition: 'all 300ms ease-in-out',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: '#EAE9FC',
    },
  },

  itemGrid: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 0.5rem',
  },

  searchInput: {
    marginTop: '1rem',
    width: '100%',
  },
}))

export { useStyles }
